
// Related articles for the armpit rash and itching article
export const armpitRashItchyRelatedArticles = [
  {
    id: "underarm-rash-remedies",
    slug: "effective-remedies-underarm-rash",
    title: "5 Effective Remedies for Underarm Rash"
  },
  {
    id: "armpit-health-basics",
    slug: "armpit-health-basics",
    title: "Armpit Health: The Basics Everyone Should Know"
  },
  {
    id: "deodorant-guide",
    slug: "the-ultimate-deodorant-guide",
    title: "The Ultimate Deodorant Guide: Finding the Perfect Product for Your Needs"
  }
];
